export default __webpack_public_path__ + "static/media/danie_dnia_2.221cafdf.svg";